import applyapis from "../../api/score.js";
import apis  from "../../api/flow";
import {dateUtils} from "../../utils/dateUtils";
import {utils} from "../../utils/utils";
 
export default {
    name: "BankBossAudit",
    props: {
        visible: {
            type: Boolean,
            require: false
        },
        propsOne: String
    },
    data() {
        return {
            activeName: 'first',
            scrollHeight: 400,
            query: {
                userName: "",
            },
            isVisible: this.visible,
            detailResult: {},
            caseResult:["","","",""],
            dataShow:false,
            sxdataList:[],
            sxdata:[],
            sxtype:0,
            labelList:["失信被执行","被执行","严重违法","裁判文书"],
            AllData:[[],[],[],[]],
            pageIndex:1,
            pageSize:10,
            mlShow:false,

            flowInfo: {
                ApplyID:'',
                UserId:'',
                Phone:'',
                PersonCompanyText:'',
                PersonCompanyFlag:'',
                PersonCompanyKey:'',
                LoanTipsId:'',
                Money:'',
                CreateTime:'',
                BankID:'',
                BankSiteID:'',
                SiteDirectorID:'',
                FirstBusiness:'',
                SecondBusiness:'',
                PeopleCount:'',
                LastYearIncome:'',
                LastYearTax:'',
                LastYearProfit:'',
                FinalMoney:null,
                EntrustedGuarantee:null,
                LoanYear:null,
                LoanTime:null,
            },
            fileList: [],
            fileList_FJ: [],
            picList: [],
            flowLogs:[],
            reasonVisible: false,
            queryTime: dateUtils.dateToStr("yyyy-MM-dd hh:mm:00", new Date()),
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            stepsStatus: 2,
            errorflag: false,
            secondBusinessTitle:'二级业务',
            loanApply:{
               
            },
            loanAudit: {
                Id:null,
                Business:null,
                BusinessDetail:null,
                RiskSharing:null,
                LoanCode:null,
                LoanRate:null,
                State:null,
                LoanMonth:null,
                FristInquirer:null,
                SecondInquirer:null,
                Category:null,
                hknl_value3:null,
                CreditRating:null,
                TotalAssets:null,
                AssetCoverage:null,
                SaleProceeds:null,
                NetProfits:null,
                Ratal:null,
                LoanBalance:null,
                GuaranteeType:3,
                Guarantor:null,
                GuarantorCode:null,
                CustomProperty:null,
                CustomType:null,
                ReturnMoneyStatus:null,
                GuaranteeLetterTime:null,
                LoanEndTime:null,
                LoanMoney:null,
                EntrustedGuarantee:null,
                AccountManager:null,
                AccountManagerPhone:null,
                ProTypeId:null,
                Area:null,
                GuaranteeRate:null,
                xyzk_value5:null,
                xyzk_value4:null,
                xyzk_value3:null,
                xyzk_value2:null,
                xyzk_value1:null,
                hknl_value1:null,
                hknl_value2:null,
                dbcs_value1:null,
                dbcs_value2:1,
                hknl_value3:null
            },
            scorelist:[0,0,0,0,0,0],
            zxbglist:[],
            loanMortgage: [],
            loanCredit: {
                Id: null,
                keyword: null,
                num: null,
                createTime: null,
                danwei: null,
                money: null,
                comment2: null,
                comment2_gm: null,
                comment2_xy: null,
                comment2_js: null,
                comment: null,
                comment_xy: null,
                comment_gm: null,
                comment_js: null
            },
            loanCreditArea: {
                Id: null,
                keyword: null,
                name: null,
                area: null,
            },
            llTableData:[],
            contractObj:null,
            bankInfoObj:{},
            xyzk_list1:[{value:1,label:"无任何逾期"},
          {value:2, label:"轻微逾期，已结清"},
          {value:3, label:"多次逾期，无严重违约"},
          {value:4,label:"严重逾期或当前逾期"},
          {value:0,label:"无数据"},
        ],
        xyzk_list2:[{value:1,label:"近半年征信查询小于5次"},
          {value:2, label:"近半年征信贷款查询5-10次"},
          {value:3, label:"近半年征信贷款查询10次以上"},
          {value:0,label:"无数据"},
        ],
        xyzk_list3:[{value:1,label:"无诉讼记录"},
          {value:2, label:"已结案小额诉讼"},
          {value:3, label:"多未结案或大额诉讼"},
          {value:4,label:"频繁涉及诉讼"},
          {value:0,label:"无数据"},
        ],
        xyzk_list4:[{value:1,label:"已婚本地有房"},
          {value:2, label:"未婚本地有房"},
          {value:3, label:"已婚本地无房"},
          {value:4,label:"未婚本地无房"},
          {value:0,label:"无数据"},
        ],
        xyzk_list5:[{value:1,label:"经营稳定，盈利良好"},
          {value:2, label:"经营一般，盈利波动"},
          {value:3, label:"经营困难，当年亏损"},
          {value:4,label:"经营困难，连续亏损"},
          {value:0,label:"无数据"},
        ],
        hknl_list1:[{value:1,label:"资产负债率低"},
        {value:2, label:"资产负债率适中"},
        {value:3, label:"资产负债率偏高"},
        {value:4,label:"资产负债率过高"},
        {value:0,label:"无数据"},
        ],
        hknl_list2:[{value:1,label:"收入稳定，现金流充足"},
        {value:2, label:"收入一般，现金流尚可"},
        {value:3, label:"收入波动，现金流紧张"},
        {value:0,label:"无数据"},
        ],
        hknl_list3:[{value:1,label:"便于流通变现价值高于贷款金额"},
        {value:2, label:"便于流通变现价值低于贷款金额"},
        {value:3, label:"不便于流通变现"},
        {value:4, label:"无法办理正式抵押登记手续且不便于流通变现"},
        {value:5, label:"无法办理正式抵押登记手续且不便于流通变现"},
        {value:0,label:"无数据"},
        ],
        dbcs_list1:[{value:1,label:"信用优秀，担保能力强"},
        {value:2, label:"信用良好，担保能力适中"},
        {value:3, label:"信用一般，担保能力较弱"},
        {value:4,label:"信用较差，担保能力有限"},
        {value:5,label:"非有效担保人"},
        {value:0,label:"无数据"},
        ],
        dbcs_list2:[{value:1,label:"正式抵押+保证人"},
        {value:2, label:"正式抵押"},
        {value:3, label:"保证人"},
        {value:4, label:"无保证人或抵押物"},
        {value:0,label:"无数据"},
        ],
        areascorelist:["","",""],
        hanShow:false,
        auditShow:false,
            rules: {
                FinalMoney:[
                    { required: true, message: '请填写最终贷款金额', trigger: 'change' },
                    { type: 'integer', message: '最终贷款金额必须为数值', trigger: 'change'},
                ],
                LoanYear: [
                  { required: true, message: '请填写担保函年份', trigger: 'change' },
                ],
                LoanTime:[
                    { required: true, message: '请填写担保函序号', trigger: 'change' },
                ],
                EntrustedGuarantee: [
                    { required: true, message: '请填写委托担保合同号', trigger: 'change' }
                ],
            },
            model: {
                Title:'',
                Jkrmc:'',
                Type:1,
                Jkr:'',
                Sfzh:'',
                Tjje:'',
                Tjjedx:'',
                Qx:12,
                Sj:dateUtils.dateToStr("yyyy年MM月dd日",new Date()),
                Hjhbh:''
            },
            model2: {
                Title:'',
                Jkrmc:'',
                Type:2,
                Jkr:'',
                Sfzh:'',
                Tjje:'',
                Tjjedx:'',
                Qx:12,
                Sj:dateUtils.dateToStr("yyyy年MM月dd",new Date()),
                Hjhbh:''
            },
            newObj:null
        };
    },
    beforeCreate: function () {
        let meta = this.$route.meta
        if (meta && meta.permBtns.length > 0) {
            this.permBtns = meta.permBtns
        }
    },
    created() {
    },
    mounted() {
        let that = this;
        that.calcTableHeight();
        // 注：window.onresize只能在项目内触发1次
        window.onresize = function windowResize() {
            that.calcTableHeight();
        }
    },
    methods: {
      onGetScore(){
        var data=this.newObj;
        var list=[
          [0,100,90,60,0],
          [0,100,70,0],
          [0,100,90,60,40],
          [0,100,80,70,0],
          [0,100,80,70,20],
          [0,100,90,80,60],
          [0,100,80,30],
          [0,100,90,70,60,40],
          [0,100,90,60,30,10],
          [0,100,80,70,0],
        ]
        var qzlist=[10,5,10,5,10,10,5,10,15,20];
        var datalist=[0,0,0,0,0,0,0,0,0,0];
        datalist[0]=data.xyzk_value1?data.xyzk_value1:0;
        datalist[1]=data.xyzk_value2?data.xyzk_value2:0;
        datalist[2]=data.xyzk_value3?data.xyzk_value3:0;
        datalist[3]=data.xyzk_value4?data.xyzk_value4:0;
        datalist[4]=data.xyzk_value5?data.xyzk_value5:0;
        datalist[5]=data.hknl_value1?data.hknl_value1:0;
        datalist[6]=data.hknl_value2?data.hknl_value2:0;
        datalist[7]=data.hknl_value3?data.hknl_value3:0;
        datalist[8]=data.dbcs_value1?data.dbcs_value1:0;
        datalist[9]=data.dbcs_value2?data.dbcs_value2:0;
        var scorelist=[0,0,0,0,0,0];
        scorelist[0]=list[0][datalist[0]]*qzlist[0]+list[1][datalist[1]]*qzlist[1]+
        list[2][datalist[2]]*qzlist[2]+list[3][datalist[3]]*qzlist[3]+list[4][datalist[4]]*qzlist[4];
        scorelist[1]=list[5][datalist[5]]*qzlist[5]+list[6][datalist[6]]*qzlist[6]+list[7][datalist[7]]*qzlist[7]
        scorelist[2]=list[8][datalist[8]]*qzlist[8]+list[9][datalist[9]]*qzlist[9]
        if(data.LastYearTax>100)scorelist[3]+=500;
        scorelist[4]=scorelist[0]+scorelist[1]+scorelist[2]+scorelist[3]
        for(var i=0;i<5;i++){
          scorelist[i]=scorelist[i]*0.01;
        }
        // this.scorelist=scorelist;
        if(data.AssetCoverage!=""&&data.TotalAssets!=""){
          var value=Number(data.TotalAssets)*
          (65-Number(data.AssetCoverage))*scorelist[4]*0.0001;
          if(value>0){
            var max=100;
            if(data.PersonCompanyText=="company")max=500;
            value=value>max?max:value;
            scorelist[5]=value.toFixed(2);
          }
      }
        this.newObj.Score1=scorelist[0]
        this.newObj.Score2=scorelist[1]
        this.newObj.Score3=scorelist[2]
        this.newObj.Score4=scorelist[3]
        this.newObj.Score=scorelist[4]
        this.newObj.PreCredit=scorelist[5]
      },
      changeAssetCoverage(){
        if(this.newObj.AssetCoverage){
        var num=Number(this.newObj.AssetCoverage)
        if(num<30)this.newObj.hknl_value1=1;
        else if(num>=30&&num<40)this.newObj.hknl_value1=2;
        else if(num>=40&&num<50)this.newObj.hknl_value1=3;
        else if(num>=50)this.newObj.hknl_value1=4;
      }
      else {
        this.newObj.hknl_value1="";
      }
        this.changeHknl2();
        this.onGetScore()
      },
      changeHknl2(){
        if(!this.newObj.LastYearIncome)return
        if(!this.newObj.TotalAssets)return
        if(!this.newObj.AssetCoverage)return
        var num1=Number(this.newObj.LastYearIncome)
        var num2=Number(this.newObj.TotalAssets)
        var num3=Number(this.newObj.AssetCoverage)
        var num4=num2*num3/100;
        if(num1<=num4)this.newObj.hknl_value2=3;
        else if(num1>num4&&num1<num4*2)this.newObj.hknl_value2=2;
        else if(num1>=num4*2)this.newObj.hknl_value2=1;
        this.onGetScore()
      },
      addScore(){
        this.newObj = {
          xyzk_value1:null,
          xyzk_value1:null,
          xyzk_value1:null,
          xyzk_value1:null,
          xyzk_value1:null,
          hknl_value1:null,
          hknl_value2:null,
          hknl_value3:0,
          dbcs_value1:null,
          dbcs_value2:0,
          Score:0,
          Score1:0,
          Score2:0,
          Score3:0,
          Score4:0,
          PreCredit:0,
          TotalAssets:this.flowInfo.TotalAssets,
          AssetCoverage:this.flowInfo.AssetCoverage,
          LastYearIncome:this.flowInfo.LastYearIncome,
          LastYearProfit:this.flowInfo.LastYearProfit,
          LastYearTax:this.flowInfo.LastYearTax,
          PeopleCount:this.flowInfo.PeopleCount,
        }
        this.changeAssetCoverage()
      },
        convertCurrency(currencyDigits) {
            var MAXIMUM_NUMBER = 99999999999.99;
            var CN_ZERO = "零";
            var CN_ONE = "壹";
            var CN_TWO = "贰";
            var CN_THREE = "叁";
            var CN_FOUR = "肆";
            var CN_FIVE = "伍";
            var CN_SIX = "陆";
            var CN_SEVEN = "柒";
            var CN_EIGHT = "捌";
            var CN_NINE = "玖";
            var CN_TEN = "拾";
            var CN_HUNDRED = "佰";
            var CN_THOUSAND = "仟";
            var CN_TEN_THOUSAND = "万";
            var CN_HUNDRED_MILLION = "亿";
            var CN_SYMBOL = "";
            var CN_DOLLAR = "";
            var CN_TEN_CENT = "";
            var CN_CENT = "";
            var CN_INTEGER = "";
           
           
            var integral; 
            var decimal;
            var outputCharacters; 
            var parts;
            var digits, radices, bigRadices, decimals;
            var zeroCount;
            var i, p, d;
            var quotient, modulus;
           
           
            currencyDigits = currencyDigits.toString();
            let strtemp = ''
            if (currencyDigits == "") {
              return "";
            }else{
              strtemp = currencyDigits.split("-");
              if (strtemp.length > 1) {currencyDigits=strtemp[1]}
            }
            if (currencyDigits.match(/[^,.\d]/) != null) {
              return "";
            }
            if ((currencyDigits).match(/^((\d{1,3}(,\d{3})*(.((\d{3},)*\d{1,3}))?)|(\d+(.\d+)?))$/) == null) {
              return "";
            }
           
           
            currencyDigits = currencyDigits.replace(/,/g, ""); 
            currencyDigits = currencyDigits.replace(/^0+/, ""); 
           
            if (Number(currencyDigits) > MAXIMUM_NUMBER) {
              return "";
            }
            parts = currencyDigits.split(".");
            if (parts.length > 1) {
              integral = parts[0];
              decimal = parts[1];
              decimal = decimal.substr(0, 2);
            }else {
              integral = parts[0];
              decimal = "";
            }
            digits = new Array(CN_ZERO, CN_ONE, CN_TWO, CN_THREE, CN_FOUR, CN_FIVE, CN_SIX, CN_SEVEN, CN_EIGHT, CN_NINE);
            radices = new Array("", CN_TEN, CN_HUNDRED, CN_THOUSAND);
            bigRadices = new Array("", CN_TEN_THOUSAND, CN_HUNDRED_MILLION);
            decimals = new Array(CN_TEN_CENT, CN_CENT);
            outputCharacters = "";
            if (Number(integral) > 0) {
              zeroCount = 0;
              for (i = 0; i < integral.length; i++) {
                p = integral.length - i - 1;
                d = integral.substr(i, 1);
                quotient = p / 4;
                modulus = p % 4;
                if (d == "0") {
                  zeroCount++;
                }else {
                  if (zeroCount > 0){
                    outputCharacters += digits[0];
                  }
                  zeroCount = 0;
                  outputCharacters += digits[Number(d)] + radices[modulus];
                }
                if (modulus == 0 && zeroCount < 4) {
                  outputCharacters += bigRadices[quotient];
                }
              }
              outputCharacters += CN_DOLLAR;
            }
           
            if (decimal != "") {
              for (i = 0; i < decimal.length; i++) {
                d = decimal.substr(i, 1);
                if (d != "0") {
                  outputCharacters += digits[Number(d)] + decimals[i];
                }
              }
            }
            if (outputCharacters == "") {
              outputCharacters = CN_ZERO + CN_DOLLAR;
            }
            if (decimal == "" || decimal == 0) {
              outputCharacters += CN_INTEGER;
            }
            outputCharacters = CN_SYMBOL + outputCharacters;
            return outputCharacters;
          },
          onExportWord(flag){
            let that = this;
            let queryPara = utils.deepCopy(that.model)
            switch(flag){
              case 1:
                queryPara = utils.deepCopy(that.model)
                break
              case 2:
                queryPara = utils.deepCopy(that.model2)
                break
            }
            queryPara.FlowId = that.flowInfo.Id
            apis.exportWord(queryPara).then(res => {
                if(res){
                  window.open(res)
                }
            });
          },
          onSubmit(flag){
            let that = this
              this.$confirm('确认生成?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              }).then(() => {
                let queryPara = utils.deepCopy(that.model)
                switch(flag){
                  case 1:
                    queryPara = utils.deepCopy(that.model)
                    break
                  case 2:
                    queryPara = utils.deepCopy(that.model2)
                    break
                }
                queryPara.FlowId = that.flowInfo.Id
                let param = {
                    wordInfo:queryPara
                }
                apis.confirmComplWord2(param).then((res) => {
                  if(res){
                    that.contractObj={
                        HTType:flag,
                        WordPath:res
                    }
                    that.activeName="second";
                    that.hanShow=false;
                    that.$message("生成成功");

                  }else{
                    this.$message({
                      message: "生成失败",
                      type: "error"
                    });
                  }
                })
              })
          },
          onMoneyChange(value){
            this.model.Tjjedx = this.convertCurrency(value)
          },
          onMoneyChange2(value){
            this.model2.Tjjedx = this.convertCurrency(value)
          },




        onChangeClose() {
            this.isVisible = false
        },
        onChangeOpen() {
            this.isVisible = true
        },
        hanget(){
            this.hanShow=true;
            var that=this;
            var res=this.flowInfo;
            this.activeName="six"
            that.model={
                Title:"湖北省农业信贷融资担保有限公司:",
                Type:1,
                Jkrmc:res.PersonCompanyText,
                Jkr:res.Name,
                Sfzh:res.IdNum,
                Tjje:res.FinalMoney,
                Tjjedx:that.convertCurrency(res.FinalMoney),
                Qx:12,
                Sj:dateUtils.dateToStr("yyyy年MM月dd日",new Date()),
                Hjhbh:res.LoanTime,
              }
              that.model2 = {
                Title:res.BankName+":",
                Type:2,
                Jkrmc:res.PersonCompanyText,
                Tjje:res.FinalMoney,
                Tjjedx:that.convertCurrency(res.FinalMoney),
                TyName:"枝江市天雨农业融资担保有限公司",
                Qx:12,
                Sj:dateUtils.dateToStr("yyyy年MM月dd日",new Date()),
                Hjhbh:res.LoanTime,
              }
        },
        setEmpty(){
            this.llTableData=[]
            this.loanAudit={}
            this.areascorelist=["","",""]
            this.hanShow=false;
            this. model= {
                Title:'湖北省农业信贷融资担保有限公司:',
                Jkrmc:'',
                Type:1,
                Jkr:'',
                Sfzh:'',
                Tjje:'',
                Tjjedx:'',
                Qx:'',
                Sj:dateUtils.dateToStr("yyyy年MM月dd日",new Date()),
                Hjhbh:''
            }
            this.model2={
                Title:'湖北枝江农村商业银行股份有限公司:',
                Jkrmc:'',
                Type:2,
                Jkr:'',
                Sfzh:'',
                Tjje:'',
                Tjjedx:'',
                Qx:'',
                Sj:dateUtils.dateToStr("yyyy年MM月dd",new Date()),
                Hjhbh:''
            }
            this.flowInfo={
                ApplyID:'',
                UserId:'',
                Phone:'',
                PersonCompanyText:'',
                PersonCompanyFlag:'',
                PersonCompanyKey:'',
                LoanTipsId:'',
                Money:'',
                CreateTime:'',
                BankID:'',
                BankSiteID:'',
                SiteDirectorID:'',
                FirstBusiness:'',
                SecondBusiness:'',
                PeopleCount:'',
                LastYearIncome:'',
                LastYearTax:'',
                LastYearProfit:'',
                FinalMoney:null,
                EntrustedGuarantee:null,
                LoanYear:null,
                LoanTime:null,
            }
            this.contractObj=null
            this.newObj=null
        },
        queryData(row,type) {
            let that = this
            this.setEmpty()
            if(type=="update"){this.auditShow=true;this.activeName="second"}
            else {this.auditShow=false;this.activeName="first";}
            if (row) {
                applyapis.getapplyOnlineById({Id: row.ApplyID}).then((res) => {
                    that.flowInfo = res;
                    if(that.flowInfo&&that.flowInfo.FinalMoney){
                        that.flowInfo.FinalMoney = utils.deepCopy(that.flowInfo.FinalMoney)*1.0/1000000
                    }
                    if(that.flowInfo.FrontImg){
                        that.flowInfo.FrontImg=PLATFROM_CONFIG.baseUrl+"/fileUploadData/"+that.flowInfo.FrontImg
                        that.flowInfo.BackImg=PLATFROM_CONFIG.baseUrl+"/fileUploadData/"+that.flowInfo.BackImg
                        that.flowInfo.PersonImg=PLATFROM_CONFIG.baseUrl+"/fileUploadData/"+that.flowInfo.PersonImg
                    }
                    if(res.HTType){
                      that.contractObj={
                        HTType:res.HTType,
                        WordPath:res.HTSrc
                      }
                    }
                    if (res.State == 3||res.State == 5) {
                        that.errorflag = true;
                    }else{
                        that.errorflag = false;
                    }
                    if(res.areaList&&res.areaList.length>0){
                        that.llTableData=res.areaList;
                            var age=that.getAge(that.flowInfo.IdNum);
                            that.areascorelist[0]=age;
                            if(age>17&&age<60){
                              var n=0;
                            for(var i=0;i<that.llTableData.length;i++){
                             n+=Number(that.llTableData[i].area)
                            }
                            if(n==0)that.areascorelist[2]=5;
                            else if(n>=20)that.areascorelist[2]=20;
                            else if(n>=10)that.areascorelist[2]=10;
                            else that.areascorelist[2]=8;
                            that.areascorelist[1]=n;
                            }


                    }
                    if(res.scoreobj)that.loanAudit=res.scoreobj;
                })
            }
        },
        getAge(idCard) {
            const birthday = idCard.match(/\d{6}(\d{4})(\d{2})(\d{2})/);
          if (birthday) {
          const year = parseInt(birthday[1]);
          const month = parseInt(birthday[2]);
          const day = parseInt(birthday[3]);
           const today = new Date();
             let age = today.getFullYear() - year;
           if (today.getMonth() < month - 1 || (today.getMonth() == month - 1 && today.getDate() < day)) {
                 age--;
                }
          return age;
         } else {
           return -1; // 身份证号不合法
      }
     },
        beforeAvatarPicUpload(file) {
            let that = this
            const isJPG =
                file.type === "image/jpg" ||
                file.type === "image/jpeg" ||
                file.type === "image/png"
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isJPG) {
                that.$message.error("仅支持jpg、png格式的图片")
            }
            if (!isLt2M) {
                that.$message.error("上传图片大小不能超过2MB")
            }
            return isJPG && isLt2M
        },
        uploadPicFile(item) {
            let that = this
            let fileObj = item.file
            const form = new FormData()
            form.append("file", fileObj)
            apis.uploadFile(form).then(res => {
                that.picList.push({
                    name: that.getFileName(res.fullPath),
                    url: res.fullPath
                })
            });
        },
        beforeAvatarFileUpload(file) {
            let that = this
            const isLt2M = file.size / 1024 / 1024 < 10
            if (!isLt2M) {
                that.$message.error("上传文件大小不能超过10MB")
            }
            return true
        },
        uploadFileFile(item) {
            let that = this
            let fileObj = item.file
            const form = new FormData()
            form.append("file", fileObj)
            apis.uploadFile(form).then(res => {
                that.fileList.push({
                    name: that.getFileName(res.fullPath),
                    url: res.fullPath
                })
            });
        },
        getFileName(path) {
            var pos1 = path.lastIndexOf('/');
            var pos2 = path.lastIndexOf('\\');
            var pos = Math.max(pos1, pos2)
            if (pos < 0)
                return path;
            else
                return path.substring(pos + 1);
        },
        handlePicRemove(file) {
            let that = this
            if (file) {
                for (let i = 0; i < that.picList.length; i++) {
                    if (file.url === that.picList[i].url) {
                        that.picList.splice(i, 1)
                    }
                }
            }
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handlePicDownload(file) {
            if (file) {
                const blob = new Blob([file.url], {type: 'application/vnd.ms-excel'})
                const elink = document.createElement('a')
                elink.download = file.name
                elink.style.display = 'none'
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)
                elink.click()
                URL.revokeObjectURL(elink.href)
                document.body.removeChild(elink)
            }
        },
        /**
         * 银行拒绝通过
         */
        onReturnFlow() {
            let that = this
            this.$prompt('', '必须填写拒绝的原因', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputErrorMessage: '必须填写原因',
                inputValidator: (value) => {
                    if (value.trim().length < 1) {
                        return false
                    }
                },
                beforeClose: (action, instance, done) => {
                    if (action == 'confirm') {
                        let value = instance.inputValue
                        if (value && value != '') {
                            let param = {
                                ApplyID: that.flowInfo.ApplyID,
                                RefuseReason: value,
                                State: '3',
                            }
                            applyapis.updateOnlineApply(param).then((res) => {
                                if (res) {
                                    done()
                                } else {
                                    that.$message({
                                        message: res.msg,
                                        type: "error"
                                    });
                                }
                            })
                        }
                    } else {
                        done()
                    }
                }
            }).then(({value}) => {
                that.onChangeClose()
                that.$parent.bankAuditSucess();
            }).catch(() => {

            });
        },
        calcTableHeight() {
            this.$nextTick(() => {
                var height1 = $(".content-box .content").height();
                var height = height1 - 150 - 20;
                this.scrollHeight = height;
            });
        },
        
      /**
       * 审核通过
       */
      onPassFlow(){
        let that = this
        var flowInfo={
            ApplyID:that.flowInfo.ApplyID,
            State:2,
            FinalMoney:that.flowInfo.FinalMoney*1000000,
            LoanYear:that.flowInfo.LoanYear,
            LoanTime:that.flowInfo.LoanTime
          }
        var PreCredit=null;
        if(this.newObj)PreCredit=this.newObj.PreCredit;
        else PreCredit=this.loanAudit.PreCredit;
        if(!PreCredit)PreCredit=this.areascorelist[2];
        if(!PreCredit){
            that.$message({
                message: "预授信为空",
                type: "error"
              });
              return;
         }
         if(!this.contractObj){
            that.$message({
                message: "请先生成担保函",
                type: "error"
              });
              return;
         }
        //  if(that.flowInfo.FinalMoney>PreCredit){
        //     that.$message({
        //         message: "预授信小于贷款金额",
        //         type: "error"
        //       });
        //       return;
        //  }
         flowInfo.HTType=this.contractObj.HTType
         flowInfo.HTSrc=this.contractObj.WordPath
         flowInfo.newObj=this.newObj;
        that.$refs["ruleForm"].validate((valid) => {
            if (valid) {
                applyapis.updateOnlineApply(flowInfo).then((res) => {
                    if(res){
                      that.onChangeClose()
                      that.$parent.bankAuditSucess();
                    }else{
                        that.$message({
                        message: res.msg,
                        type: "error"
                      });
                    }
                  })
            } else {
              return false;
            }
        });
      },
        /**
         * 银行通过
         */
        toViewUrl(type) {
            if (type == 1) {
                window.open(this.flowInfo.ViewUrl)
                if (this.flowInfo.cpViewUrl) window.open(this.flowInfo.cpViewUrl)
            } else {
                window.open(this.flowInfo.DownLoadUrl)
                if (this.flowInfo.cpDownLaodUrl) window.open(this.flowInfo.cpDownLaodUrl)
            }
        },
        changeSecondBusinessShow(value) {
            switch (value) {
                case '电商':
                    this.secondBusinessTitle = '销售类目'
                    break;
                case '种植':
                    this.secondBusinessTitle = '种植作物'
                    break;
                case '养殖':
                    this.secondBusinessTitle = '养殖种类'
                    break;
                case '农产品加工':
                    this.secondBusinessTitle = '加工品类'
                    break;
                case '农资农机销售':
                    this.secondBusinessTitle = '销售品类'
                    break;
                case '农产品购销':
                    this.secondBusinessTitle = '产品类型'
                    break;
                case '农业服务':
                    this.secondBusinessTitle = '服务项目'
                    break;
                case '农业旅游农家乐':
                    this.secondBusinessTitle = '产业类型'
                    break;
                case '农业相关工程':
                    this.secondBusinessTitle = '工程内容'
                    break;
                case '其他':
                    this.secondBusinessTitle = '经营项目'
                    break;
            }
        },
        onDownChange(path){
          window.open(path)
        }
    },
};
